import axios from "axios";

const DOCUMENT_API_URL = process.env.REACT_APP_DOCUMENT_BASE_URL;
const DOCUMENT_STORAGE = process.env.REACT_APP_SUPPORT_DOC_STORAGE;

const downloadDocument = async (filePath, fileExtension) => {
  const route = `Document/File/${DOCUMENT_STORAGE}/documents`;
  const url = `${DOCUMENT_API_URL}${route}`;
  const response = await axios.get(url, {
    params: {
      FilePath: filePath,
      FileExtension: fileExtension,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("userToken")}`,
    },
  });

  return response.data;
};

export { downloadDocument };
